import { ReactNode } from "react";

export function VoteResult({ title, yes, no, maybe }: { title: ReactNode, yes: number, no: number, maybe: number }) {
    return <div className="vote-result">
        <div className="vote-result-bar">
            {yes > 0 && <div className="vote-result-yes" style={{ flexGrow: yes }} />}
            {maybe > 0 && <div className="vote-result-maybe" style={{ flexGrow: maybe }} />}
            {no > 0 && <div className="vote-result-no" style={{ flexGrow: no }} />}
            {yes === 0 && no === 0 && maybe === 0 && <div className="vote-result-none" />}
        </div>
        <div className="vote-result-title">{title}</div>
    </div>;
}
